import { Client } from '../redux/reducers/clients'
import { fetchRequest } from '../services/http.service'

export const GET_DOCUMENT_TEMPLATES_URL = '/documents/templates'
export const GENERATE_DOCUMENTS_URL = '/documents/generate'
export const GET_CLIENT_DOCUMENTS_URL = '/documents/client'
export const UPLOAD_SCAN_URL = '/documents/scan'
export const CLIENT_LOOKUP_URL = '/client/lookup'

// Sablony apex-generatoru (territory 2)
export interface ApexTemplate {
  path: string
  name: string
}

// Dokumenty imperium-generatoru (territory 1)
export interface ImperiumTemplate {
  id: string
  label: string
  staticky_pdf: boolean
}

export interface ClientDocument {
  clientDocumentId: number
  clientId: number
  documentType: string | null
  strategy: string | null
  templateKey: string | null
  state: string
  version: number
  source: string
  relatedDocumentId: number | null
  fileName: string
  mimeType: string | null
  fileSize: number | null
  createdAt: string
  createdByName: string | null
  signedAt: string | null
  archivedAt: string | null
}

export interface DocumentFile {
  fileName: string
  mimeType: string
  content: string
}

export interface GenerateDocumentsRequest {
  clientId?: number
  client?: Partial<Client>
  sablona?: string
  dokumenty?: string[]
  format: 'pdf' | 'docx'
  data: Record<string, any>
  sendCredentials?: boolean
  sendWelcomeEmail?: boolean
}

export interface GenerateDocumentsResponse {
  clientId: number
  clientIncomplete: boolean | null
  documents: ClientDocument[]
  file: DocumentFile
  credentialsSent: boolean | null
  welcomeEmailSent: boolean | null
  clientEmailError: string | null
}

export interface UploadScanRequest {
  clientId: number
  fileName: string
  fileContent: string
  relatedDocumentId?: number
}

export const getDocumentTemplatesRequest = <T>() => fetchRequest.get<T>(GET_DOCUMENT_TEMPLATES_URL)

export const generateDocumentsRequest = (request: GenerateDocumentsRequest) =>
  fetchRequest.post<GenerateDocumentsResponse>(GENERATE_DOCUMENTS_URL, request)

export const getClientDocumentsRequest = (clientId: number) =>
  fetchRequest.get<ClientDocument[]>(GET_CLIENT_DOCUMENTS_URL + '/' + clientId)

export const downloadDocumentRequest = (documentId: number) =>
  fetchRequest.get<DocumentFile>(`/documents/${documentId}/download`)

export const uploadScanRequest = (request: UploadScanRequest) =>
  fetchRequest.post<ClientDocument>(UPLOAD_SCAN_URL, request)

export const lookupClientRequest = (personalNumber: string, companyId: string) => {
  let params = ''
  params += personalNumber ? 'personalNumber=' + personalNumber : ''
  params += companyId ? (params ? '&' : '') + 'companyId=' + companyId : ''
  return fetchRequest.get<Client[]>(CLIENT_LOOKUP_URL + (params ? '?' + params : ''))
}
